"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaNetworkOptionsResponseVersionToJSON = exports.RosettaNetworkOptionsResponseVersionFromJSONTyped = exports.RosettaNetworkOptionsResponseVersionFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaNetworkOptionsResponseVersionFromJSON(json) {
    return RosettaNetworkOptionsResponseVersionFromJSONTyped(json, false);
}
exports.RosettaNetworkOptionsResponseVersionFromJSON = RosettaNetworkOptionsResponseVersionFromJSON;
function RosettaNetworkOptionsResponseVersionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rosetta_version': json['rosetta_version'],
        'node_version': json['node_version'],
        'middleware_version': !runtime_1.exists(json, 'middleware_version') ? undefined : json['middleware_version'],
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaNetworkOptionsResponseVersionFromJSONTyped = RosettaNetworkOptionsResponseVersionFromJSONTyped;
function RosettaNetworkOptionsResponseVersionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rosetta_version': value.rosetta_version,
        'node_version': value.node_version,
        'middleware_version': value.middleware_version,
        'metadata': value.metadata,
    };
}
exports.RosettaNetworkOptionsResponseVersionToJSON = RosettaNetworkOptionsResponseVersionToJSON;
//# sourceMappingURL=RosettaNetworkOptionsResponseVersion.js.map